import baseMoment from 'moment-timezone';

// Keep the teacher calendar in Rome without changing the student's timezone.
export default function romeMoment(value, ...args) {
  const wallTime = typeof value === 'string' && !/(?:Z|[+-]\d\d:\d\d)$/.test(value);
  const result = wallTime ? baseMoment.tz(value, ...args, 'Europe/Rome') : baseMoment(value, ...args).tz('Europe/Rome');
  result.local = () => result.tz('Europe/Rome');
  return result;
}
Object.assign(romeMoment, baseMoment);

const formats = {
  'dd.MM.yyyy': 'DD.MM.YYYY', 'HH:mm': 'HH:mm',
  'EEEE, d MMMM': 'dddd, D MMMM', 'EEEE, d MMMM · HH:mm': 'dddd, D MMMM · HH:mm',
  'dd MMMM yyyy, HH:mm': 'DD MMMM YYYY, HH:mm',
};
export function romeFormat(date, pattern) {
  return romeMoment(date).locale('ru').format(formats[pattern] || pattern);
}
export function parseRomeDateTime(date, time) {
  const value = `${date} ${time}`;
  const parsed = baseMoment.tz(value, 'YYYY-MM-DD HH:mm', true, 'Europe/Rome');
  return parsed.isValid() && parsed.format('YYYY-MM-DD HH:mm') === value ? parsed.toDate() : null;
}
